import { createApp } from 'vue';
import store from 'shared/store';
import FormBuilderBlock from 'shared/components/formBuilderBlock/FormBuilderBlock.vue';
import FormKitBuilderContainer from 'shared/components/FormKitBuilderContainer/FormKitBuilderContainer.vue';
import {
	initFormKitSchema,
	formKitSchemaOptions,
} from 'shared/utils/initFormKitSchema';

async function mountFormBuilderBlocks() {
	const formkitBuilderContainerApps = [
		...document.querySelectorAll('[data-form-builder-block]'),
	];

	if (formkitBuilderContainerApps.length === 0) {
		console.warn('[formBuilderBlock] Container not found');
		return;
	}

	const options = await formKitSchemaOptions();
	await Promise.all(
		Array.from(formkitBuilderContainerApps).map(async (item, index) => {
			const app = createApp({
				name: `form-builder-block-${index}`,
			});
			app.component('form-builder-block', FormBuilderBlock);
			app.component('form-kit-builder-container', FormKitBuilderContainer);
			await initFormKitSchema(app, options);
			app.use(store);
			app.mount(item);
		}),
	);
}

mountFormBuilderBlocks().catch((error) => {
	console.error('Error mounting FormBuilderBlocks:', error);
});

